// extracted by mini-css-extract-plugin
export default {"verificacaoAderenciaContainer":"Interesse_verificacaoAderenciaContainer__5NGv7"};